require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2016-12-17-making-sense-of-the-scaas-new-flavor-wheel.json") })
        }
      }, "path---blog-2016-12-17-making-sense-of-the-scaas-new-flavor-wheel");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2016-12-17-making-sense-of-the-scaas-new-flavor-wheel!./.cache/json/blog-2016-12-17-making-sense-of-the-scaas-new-flavor-wheel.json
// module id = 601
// module chunks = 231608221292675